import React, { useCallback } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { SnackbarProvider } from 'notistack';

import { useActionDispatcher } from '../../hooks';
import { removeNotifications } from '../../store/modules/notifications/actions';
import Notification from './Notification';

const makeTypeSet = (color: string) => ({
  color,
  background: '#FFF',
  borderBottomColor: color,
  borderBottom: 'solid 3px',
});

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    minHeight: 50,
    top: 80,
    [breakpoints.up('md')]: {
      right: 30,
    },
    '& > div': {
      padding: '6px 20px 6px 6px',
    },
  },
  default: makeTypeSet(palette.text.primary),
  success: makeTypeSet('#01B3C5'),
  error: makeTypeSet('#F8221A'),
  warning: makeTypeSet('#F8221A'),
  info: makeTypeSet('#2979FF'),
}), { name: 'Notifications' });

const Notifications = () => {
  const classes = useStyles();
  const remove = useActionDispatcher(removeNotifications);
  const handleClose = useCallback((e: React.SyntheticEvent, reason: string) => {
    if (reason !== 'clickaway') {
      remove();
    }
  }, [remove]);

  return (
    <div style={{ zIndex: 2247483647, position: 'absolute' }}>
      <SnackbarProvider
        maxSnack={5}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{
          root: classes.root,
          variantSuccess: classes.success,
          variantError: classes.error,
          variantWarning: classes.warning,
          variantInfo: classes.info,
        }}
        hideIconVariant
        autoHideDuration={5000}
      >
        <Notification />
      </SnackbarProvider>
    </div>
  );
};

export default Notifications;
